import React from 'react';
import { useDropzone } from 'react-dropzone';

const FileDropzone = ({ onFilesSelected }) => {
  const { getRootProps, getInputProps, acceptedFiles } = useDropzone({
    multiple: true,
    onDrop: (acceptedFiles) => onFilesSelected(acceptedFiles),
  });

  return (
    <div
      {...getRootProps()}
      className="dropzone"
      style={{
        border: '2px dashed #ccc',
        padding: '20px',
        borderRadius: '6px',
        textAlign: 'center',
        cursor: 'pointer',
        marginBottom: '1rem'
      }}
    >
      <input {...getInputProps()} />
      <p>Drag & drop files here, or click to select</p>
      {acceptedFiles.length > 0 && (
        <ul className="mt-2">
          {acceptedFiles.map((file) => (
            <li key={file.name}>{file.name}</li>
          ))}
        </ul>
      )}
    </div>
  );
};

export default FileDropzone;